import { createContext, useContext } from "react";

import type { CharStyleFormattingOrigin } from "src/services/character_styles/types";
import type { OutlineMode, OutlineSortMode, ReviewMode } from "src/types";

type ReviewContextType = {
  handleApprove: () => Promise<void>;
  handleApproveAll: () => Promise<void>;
  handleReject: () => Promise<void>;
  handleRejectAll: () => Promise<void>;
  handleRestyle: (newStyle: string) => Promise<void>;
  handleRestyleAll: (newStyle: string) => Promise<void>;
  handleClearCharacterStyle: () => void;
  handleClearGroup: () => void;
  handleClearStyle: () => void;
  handleNext: () => Promise<void>;
  handlePrevious: () => Promise<void>;
  handleSelectCharacterStyle: (
    name: string | null,
    origin?: CharStyleFormattingOrigin | null
  ) => void;
  handleSelectGroup: (group: string | null) => void;
  handleSelectStyle: (group: string | null, style: string | null) => void;
  handleSetBoundaryIndices: (boundaryIndices: [number, number], style?: string | null) => void;
  handleSetIgnoreParagraphs: (ignoreParagraphs: boolean) => void;
  handleSetOutlineMode: (outlineMode: OutlineMode) => Promise<void>;
  handleSetOutlineSortMode: (outlineSortMode: OutlineSortMode) => void;
  handleSetReviewMode: (reviewMode: ReviewMode) => void;
};

const ReviewContext = createContext<ReviewContextType>({} as ReviewContextType);

export const useReviewContext = () => {
  return useContext(ReviewContext);
};

export default ReviewContext;
